/* eslint-disable react/jsx-props-no-spreading  */
import React, { useState, useEffect } from 'react';
// eslint-disable-next-line import/no-extraneous-dependencies
import { CheckCircleOutlined } from '@ant-design/icons';
import { Modal, Typography, Button, Space } from 'antd';
import { t } from '../../utils/i18n';
import { localStorage } from '../../utils/namespaced-storage';
import { window } from '../../env/browser';

export function SubscriptionSuccessModal() {
  const [isModalOpen, setIsModalOpen] = useState(false);

  const checkModalState = () => {
    if (localStorage.getItem('showCBSubscriptionSuccessModal') === 'ON') {
      setIsModalOpen(true);
    }
  };

  useEffect(() => {
    checkModalState();
    window.addEventListener('storage', checkModalState);
    return () => window.removeEventListener('storage', checkModalState);
  }, []);

  const handleOnStartNowClick = () => {
    localStorage.removeItem('showCBSubscriptionSuccessModal');
    setIsModalOpen(false);
  };

  return (
    <Modal
      open={isModalOpen}
      showHeader={false}
      centered
      footer={null}
      title={null}
      closeIcon={null}
      width={400}
      className="as-SubscriptionSuccessModal"
    >
      <Space direction="vertical" size="middle">
        <Space
          direction="vertical"
          align="center"
          size="small"
          style={{ width: '100%', textAlign: 'center' }}
        >
          <CheckCircleOutlined
            style={{
              color: '#00d0be',
              fontSize: 35,
              marginBottom: 0,
            }}
            css="font-size: 20px; margin-right: 10px; color: #54B25C"
          />
          <Typography.Text style={{ fontSize: 20 }}>
            {t('subscription-success.title')}
          </Typography.Text>
        </Space>
        <Space
          direction="vertical"
          align="start"
          size="large"
          style={{ width: '100%' }}
        >
          <Typography.Text>
            {t('subscription-success.description')}
          </Typography.Text>
          <Button
            size="large"
            type="primary"
            style={{ width: '100%' }}
            onClick={handleOnStartNowClick}
          >
            {t('subscription-success.button.start-now')}
          </Button>
        </Space>
      </Space>
    </Modal>
  );
}
